import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class ProcessWorkingTableColumn extends BasicEntity {
csvIn: boolean | null;
csvInPos: number | null;
csvOut: boolean | null;
csvOutCondition: string;
csvOutName: string;
defaultValue: string;
length: string;
name: string;
notNull: boolean | null;
orderNumber: number | null;
processCode: string;
processStepCode: string;
type: string;
visionCode: string;
}

